import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=62312e68&scoped=true&"
import script from "./ProjectsList.vue?vue&type=script&lang=ts&"
export * from "./ProjectsList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=62312e68&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62312e68",
  null
  
)

export default component.exports